var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJardulik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63.15 63.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_242);\n        stroke: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_192);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        stroke-width: .25px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_242-3);\n        stroke: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_192-3);\n      }\n\n      .cls-5 {\n        fill: #353535;\n      }\n\n      .cls-6 {\n        fill: #711421;\n      }\n\n      .cls-4 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_242-2);\n        stroke: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_192-2);\n      }\n\n      .cls-7 {\n        fill: #be1622;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_242",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 242",
    x1: 33.09,
    y1: 35.05,
    x2: 48.16,
    y2: 35.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca053a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e1307"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_192",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 192",
    x1: 32.9,
    y1: 35.12,
    x2: 48.29,
    y2: 35.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e50042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e30613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#761204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_242-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 242",
    x1: 13.99,
    y1: 35.37,
    x2: 32.45,
    y2: 35.37,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_242"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_192-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 192",
    x1: 13.86,
    y1: 35.27,
    x2: 32.58,
    y2: 35.27,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_192"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_242-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 242",
    x1: 15.34,
    y1: 23.01,
    x2: 46.17,
    y2: 23.01,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_242"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_192-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 192",
    x1: 15.19,
    y1: 23.01,
    x2: 46.39,
    y2: 23.01,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_192"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 31.58,
    cy: 31.52,
    rx: 31.58,
    ry: 31.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.46,40.76c-11.43,29.81-46.68,16.46-44.21,16.51,10.74.21,20.61-4.26,18.94-21.53-.7-7.32,4.44-12.9,12.56-13.12,9.63-.26,15.95,9.67,12.7,18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.15,2.01c31.45-5.08,37.68,32.09,36.48,29.93-5.22-9.38-14.04-15.68-28.09-5.58-5.96,4.28-13.36,2.64-17.63-4.28-5.07-8.2.31-18.64,9.25-20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.89,51.36C-11.49,26.93,17.27,2.65,16.02,4.78c-5.4,9.27-6.32,20.05,9.52,26.97,6.71,2.94,8.49,10.14,5.31,17.33-4.05,7.51-16.17,9.22-21.96,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.2,35.75c.6,6-.5,9.04-1.11,11.73,5.69-3.46,16.25-12.25,14.96-22.09-.14-1.09-.72-2.16-1.3-2.76-1.19,0-2.97.16-4.99.89-1.07.39-3.12,1.13-4.83,2.87-3.42,3.49-2.89,7.82-2.74,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.16,32.05s-9.41-4.29-11.71-8.91c0,0-.19.99-.29,1.61-1.91,11.64,13.4,20.75,16.33,22.38.27.15.96.49.96.49l.11-.31c.39-1.01,3.68-10.46-5.39-15.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.66,26.35c4.72-3.47,8.93-4.99,12.51-5.13-3.84-6.01-12.32-4.08-14.7-.94-.12.16-.47.56-.47.56,0,0-.37-.42-.5-.57-2.69-3.11-11.2-5.3-15.16.76.19.39.71,1.29.96,1.66,4.31,6.65,11.54,7.94,17.37,3.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 30.76,
    cy: 31.2,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.76,
    cy: 31.38,
    r: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJardulik);
export default __webpack_public_path__ + "static/media/jardulik.9b8d96abee1ac3f1ab14f6c15c4ef94b.svg";
export { ForwardRef as ReactComponent };